export default "/images/wifi.svg?c595ca34ef4631d43928dc6495cdb28b";